module.exports = __webpack_public_path__ + "static/img/1707.35fdf44.png";